import { render, staticRenderFns } from "./CountryFlags.vue?vue&type=template&id=79164750&"
import script from "./CountryFlags.vue?vue&type=script&lang=js&"
export * from "./CountryFlags.vue?vue&type=script&lang=js&"
import style0 from "./CountryFlags.vue?vue&type=style&index=0&id=79164750&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports